// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2YzZ8","rootSuccess":"CompleteLink_rootSuccess__1A75A","rootFailure":"CompleteLink_rootFailure__CMExg","isDisabled":"CompleteLink_isDisabled__2_ZeJ"};